import { CommonDocumentService } from '@savgroup-front-common/core/api/Document';

import downloadBalancingStockItemToRegulateExportQuery from './downloadBalancingStockItemToRegulateExportQuery';
import downloadFiscalInventoryExportQuery from './downloadFiscalInventoryExportQuery';
import downloadStockInventorySheetQuery from './downloadStockInventorySheetQuery';
import { generateAndDownloadSparePartItemStockLabelQuery } from './generateAndDownloadSparePartItemStockLabelQuery';
import generateAndDownloadStockInInventorySheetQuery from './generateAndDownloadStockInInventorySheetQuery';
import { getBillingDocumentLinkQuery } from './getBillingDocumentLinkQuery';

export const DocumentService = {
  uploadFileAttachmentsFromControlCommand:
    CommonDocumentService.uploadFileAttachmentsFromControlCommand,
  getBillingDocumentLinkQuery,
  generateAndDownloadSparePartItemStockLabelQuery,
  generateAndDownloadStockInInventorySheetQuery,
  downloadBalancingStockItemToRegulateExportQuery,
  downloadFiscalInventoryExportQuery,
  downloadStockInventorySheetQuery,
  getAdditionalFileTokenQuery:
    CommonDocumentService.getAdditionalFileTokenQuery,
};
